import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { TextArea, Button, Space, Row } from "@masterteam/mt-design-react";
import api from "../../../../providers/api";
import { addToast } from "../../../../helpers";

function CommentInput({ KPIDetails, callback, data }) {
  const [Comment, setComment] = useState(data?.Comment || "");
  const [loading, setLoading] = useState(false);

  function handleSubmit() {
    const body = {
      KPIID: KPIDetails.ID,
      Comment,
      ID: data?.ID || undefined
    };
    setLoading(true);
    const action = data ? "updateComment" : "createComment";
    api.kpi[action](body)
      .then(res => {
        const { Data } = res;
        setComment("");
        addToast.success(data ? "toast.successUpdate" : "toast.successSave");
        callback(Data, action);
      })
      .catch(err => {
        addToast.error(err.message, {
          toastId: "get-users-error"
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return (
    <Space direction="vertical">
      {!data && (
        <div>
          <FormattedMessage id="common.leave-comment" />
        </div>
      )}
      <TextArea
        type="textarea"
        value={Comment}
        className="comment-fields"
        onChange={event => {
          setComment(event.target.value);
        }}
        // onKeyDown={e => e.key === "Enter" && addComment()}
      />
      <Row justify="end">
        <Button
          disabled={!Comment}
          onClick={() => handleSubmit()}
          loading={loading}
        >
          <FormattedMessage
            id={data ? "common.edit-comment" : "common.add-comment"}
          />
        </Button>
      </Row>
    </Space>
  );
}

export default CommentInput;
